<template>
    <div class="flexContainer full">
        <section id="sectionPrincipal">
            <section class="planosWrapper">
                <section class="searchResultsWrapper">
                    <loader :loading="loading" v-if="loading"></loader>
                    <section>
                        <div class="row d-flex align-items-end mb-5">
                            <div class="col">
                                <div class="row">
                                    <div class="col zone-header">
                                        <h1 class="zone-header-title">{{ $t("headerAdmin.zoneList") }}</h1>
                                    </div>
                                </div>

                                <div class="row ">
                                    <div class="col d-flex align-items-center">
                                        <input type="text" id="searchBySearch" class="rem3rch-input-text" v-model.trim="search" />
                                        <label for="searchBySearch" class="m-0 pointer ml-3"><i class="fa fa-search fa-lg color-grey"></i></label>

                                        <div class="form-group m-0 row d-flex align-items-center ml-5">
                                            <input id="rem3rch-input-checkbox" type="checkbox" class="col-auto d-none" v-model="displayDeletedZone" />
                                            <label for="rem3rch-input-checkbox" class="col-auto m-0 label-checkbox pointer d-flex align-items-center">
                                                <span v-show="displayDeletedZone" class="rem3rch-checkbox"> <i class="fa fa-check"></i> </span>
                                                <span v-if="!displayDeletedZone" class="rem3rch-checkbox"></span>
                                                <span class="label-title">{{ $trad.headerAdmin.zone.displayDeletedZone }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto">
                                <div class="zone-header d-flex flex-column">
                                    <button v-if="canManageZone()" @click="$router.push({ path: `/zones/create` })" class="btn btn-add-zone mb-4">
                                        <i class="fa fa-plus fa-xs"></i> <span class="ml-2">{{ $t("headerAdmin.zone.add") }}</span>
                                    </button>
                                    <button @click="$router.push({ path: `/zones/groups/manage` })" class="btn btn-manage-group">
                                        <span class="ml-2">{{ $t("headerAdmin.zone_group.manage") }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4" v-if="!loading">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>{{ $trad.headerAdmin.zone.client_ref }}</th>
                                        <th>{{ $trad.headerAdmin.zone.name }}</th>
                                        <th>{{ $trad.headerAdmin.zone.type }}</th>
                                        <th>{{ $trad.headerAdmin.zone.group }}</th>
                                        <th>{{ $trad.headerAdmin.zone.brands }}</th>
                                        <th>{{ $trad.headerAdmin.zone.users }}</th>
                                        <th v-if="canManageZone()">{{ $trad.headerAdmin.zone.parameters }}</th>
                                        <th>{{ $trad.common.edit }}</th>
                                        <!-- <th>copy</th> -->
                                        <th v-if="canManageZone()">{{ $trad.common.delete }}</th>
                                        <th>{{ $trad.common.history }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="notfound" v-if="filteredBrandZones.length <= 0">
                                        <td :colspan="11">{{ $trad.zonerole.notfound }}</td>
                                    </tr>
                                    <ZoneDetailBanner
                                        v-for="brandZone in filteredBrandZones"
                                        v-if="brandZone.active"
                                        :key="`active-${brandZone.zone.id}`"
                                        :brandZone="brandZone"
                                        @showUsers="showUsers(brandZone.zone)"
                                        @editTypeZone="openModalParamsEditZoneParams(brandZone)"
                                        @deleteZone="openModalDisableBrandZone(brandZone)"
                                    />
                                    <ZoneDetailBanner
                                        v-for="brandZone in filteredBrandZones"
                                        v-if="!brandZone.active && displayDeletedZone"
                                        :key="`inactive-${brandZone.zone.id}`"
                                        :brandZone="brandZone"
                                    />
                                </tbody>
                            </table>
                        </div>
                    </section>
                </section>
            </section>
        </section>
        <DisableBrandZone
            v-if="modalParamsDisableBrandZone"
            :params="modalParamsDisableBrandZone"
            @close="modalClose($event)"
            @success="loadBrandZones(true)"
        ></DisableBrandZone>
        <EditZoneParams
            v-if="modalParamsEditZoneParams"
            :params="modalParamsEditZoneParams"
            @close="modalClose($event)"
            @success="loadBrandZones(true)"
        ></EditZoneParams>
        <ShowUsers v-if="modalShow.showUsers" @cancel="modalClose($event)"></ShowUsers>
    </div>
</template>

<script>
import EditZoneParams from "./EditZoneParams.vue";
import ShowUsers from "./ShowUsers.vue";
import httpService from "../../service";
import { mapActions, mapGetters } from "vuex";
import AdminTools from "../../adminTools/Admin";
import ZoneDetailBanner from "@/components/admin/zone/ZoneDetailBanner";
import loader from "@/components/loader/loader";
import TryLoad from "@/mixins/TryLoadMixin";
import DisableBrandZone from "@/components/admin/zone/DisableBrandZone";
import { removeNbsp } from "../../../utils/string";

export default {
    components: {
        DisableBrandZone,
        loader,
        ZoneDetailBanner,
        EditZoneParams,
        ShowUsers,
        AdminTools
    },
    mixins: [TryLoad],
    data: () => ({
        loading: true,
        displayDeletedZone: false,
        brands: [],
        search: "",
        modalShow: {
            showUsers: false
        },
        modalParamsDisableBrandZone: null,
        modalParamsEditZoneParams: null,
        zone: null
    }),
    computed: {
        ...mapGetters({ getBrand: "brand/getBrand" }),
        ...mapGetters("forecast", { brandZones: "getAdminBrandZones" }),
        filteredBrandZones() {
            return this.brandZones
                .map(brandZone => {
                    brandZone.brands = this.brands.filter(b => b.allZones.find(z => z.id === brandZone.zone.id));
                    return brandZone;
                })
                .filter(brandZone => {
                    const brandZoneName = removeNbsp(brandZone.zone.name);
                    const searchString = removeNbsp(this.search).toLowerCase();
                    const zoneRelationTypeName = ((brandZone.zoneRelationType && brandZone.zoneRelationType.name) || "").toLowerCase();
                    return (
                        brandZone.id.toString().indexOf(this.search) > -1 ||
                        brandZoneName.toLowerCase().indexOf(searchString) > -1 ||
                        (brandZone.zone.refClient ? brandZone.zone.refClient.toLowerCase().indexOf(searchString) > -1 : false) ||
                        zoneRelationTypeName.indexOf(searchString) > -1 ||
                        brandZone.brands.some(b => b.name.toLowerCase().indexOf(searchString) > -1)
                    );
                })
                .map(bz => {
                    bz.zone.users = bz.zone.users.filter(u => this.brands.some(b => b.id === u.brandId));
                    return bz;
                });
        }
    },
    methods: {
        ...mapActions({ setZone: "items/setZone" }),
        ...mapActions("forecast", { populateAdminBrandZones: "populateAdminBrandZones" }),
        openModalDisableBrandZone(brandZone) {
            this.modalParamsDisableBrandZone = {
                zone: brandZone.zone,
                brandZone: brandZone,
                isActive: true
            };
        },
        openModalParamsEditZoneParams(brandZone) {
            this.modalParamsEditZoneParams = {
                zone: brandZone.zone,
                brandZone: brandZone,
                isActive: true
            };
        },
        showUsers(a) {
            this.modalShow.showUsers = true;
            this.setZone(a);
        },
        modalClose(close) {
            this.modalShow.showUsers = close;
            this.modalParamsDisableBrandZone = null;
            this.modalParamsEditZoneParams = null;
        },
        async loadBrandZones(reload = false) {
            this.loading = true;
            await this.populateAdminBrandZones({ reload, withDeleted: true });
            this.brandZones.sort((z1, z2) => {
                return z2.zone.name.toLowerCase() > z1.zone.name.toLowerCase() ? -1 : 1;
            });
            this.brands = await httpService.getWithoutCampaign("/brands");
            this.loading = false;
        },
        canManageZone() {
            return this.isSuperAdmin() || this.isClientAdmin();
        }
    },
    created() {
        this.loadBrandZones(true);
    }
};
</script>

<style lang="scss" scoped>
.planosWrapper {
    background-color: #fff;
    padding: 30px;
    padding-top: 50px;

    .zone-header {
        .zone-header-title {
            color: #6f6f6f;
            font-size: 30px;
            margin: 0;
            text-transform: uppercase;
            font-family: "Oswald", sans-serif;
            font-weight: normal;
            display: block;
            margin-bottom: 40px;
        }
        .btn-add-zone,
        .btn-manage-group {
            width: 100%;
            padding: 10px 25px;
            background-color: #000;
            color: #fff;
            span {
                text-transform: uppercase;
                font-size: 14px !important;
                font-family: "Roboto", sans-serif;
            }
        }
    }

    table {
        border-collapse: collapse;
        tr {
            &.notfound {
                height: 150px;
                td {
                    border: #343434 1px solid;
                    text-align: center;
                    font-size: 18px;
                    line-height: 18px;
                    padding: 10px;
                    color: #262626;
                    vertical-align: middle;
                }
            }

            th {
                font-family: "Oswald", sans-serif;
                font-size: 19px;
                background: #343434;
                border: #343434 1px solid;
                color: #fff;
                text-transform: uppercase;
                text-align: center;
                vertical-align: center;
                padding: 15px 10px;
                font-weight: normal;
                @media (max-width: 1440px) {
                    font-size: 16px;
                }
            }
        }
    }
}
.marginButton {
    margin: 3px;
}
.color-grey {
    color: #6f6f6f !important;
}
</style>



// WEBPACK FOOTER //
// ZoneList.vue?bc95c552